import { Nav, Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #123666;
        color: white;
        text-align: center;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
    }
`;

export const NavWrapper = styled(Nav)`
    & > li > a {
        padding: 5px 15px;
    }
    
    & > li.active > a {
        background-color: #123666;
        color: white;
    }
`;